import reducer from "./reducer";
export { default as ContractTypesSettings } from "./components/index";
export { default as contractTypesSettingsReducerName } from "./constants";
export default reducer;
